import { fromRefinement } from 'io-ts/Decoder';
import uniq from 'lodash-es/uniq';

export function fromList<T extends string | number | symbol, K extends readonly T[]>(
	theList: K
	// theList?: K | undefined
) {
	type Mutable<K> = {
		-readonly [key in keyof K]: K[key];
	};

	// if (!theList) {
	// 	return fromRefinement<unknown, never>(
	// 		(u): u is never => true,
	// 		`never`
	// 	);
	// }

	theList = uniq([...theList]) as unknown as K;

	return fromRefinement<unknown, Mutable<K>[number]>(
		(u): u is Mutable<K>[number] => theList.includes(u as T),
		`(${theList.join(' | ')})`
	);
}
